import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import DebouncableInput from 'web-app/react/components/form-elements/debouncable-input';
import { authStateContext } from 'web-app/react/contexts/auth-state';
import { TextFieldStyling } from '@famly/stat_forms_text-field-styling';
export { 
/**
 * @deprecated import from '@famly/stat_forms_text-field-styling' instead
 */
TextFieldStyling, };
const InputCSS = css `
    border-radius: ${props => props.cornerStyle === 'rounded' && '3px'};
    display: block;
    box-sizing: border-box;
    width: 100%;
    margin: 0 0 0.625rem;
    padding: 0.3125rem;
    border: 1px solid ${props => props.theme.borderConfiguration.defaultColor};
    background-color: ${props => props.theme.invertedText};
    box-shadow: inset 0 0 0 rgba(51, 51, 51, 0.1);
    font-family: inherit;
    font-size: 0.8125rem;
    font-weight: normal;
    color: ${props => props.theme.text};
    transition:
        box-shadow 0.5s,
        border-color 0.25s ease-in-out;
    appearance: none;

    &:focus {
        outline: none;
        border: 1px solid ${props => props.theme.borderConfiguration.focus};
        box-shadow: 0 0 0 ${props => props.theme.textDisabled};
    }

    ${props => props.invalid
    ? css `
                  outline: none;

                  &&:not(:focus):not(:active) {
                      box-shadow: 0 0 0 2px ${props => props.theme.accent3};
                  }
              `
    : ''}

    height: 36px;

    ${TextFieldStyling}
`;
const Input = styled(({ ispassive, invalid, textAlign, cornerStyle, ...rest }) => (_jsx(DebouncableInput, { ...rest }))) `
    ${InputCSS}
`;
const TextField = (props) => {
    const { id, type = 'text', placeholder, value, cornerStyle, textAlign, onChange, onFocus, onBlur, required = false, disabled = false, autoFocus = false, className, step, inputRef, ispassive, passive, mismatchString, ...rest } = props;
    const extraAttrs = { ...rest };
    if (step) {
        extraAttrs.step = step;
    }
    if (inputRef) {
        extraAttrs.inputRef = (input) => inputRef(input);
    }
    const { isLoggedIn } = React.use(authStateContext);
    const shouldDisallowAutoComplete = !isLoggedIn || type === 'email';
    return (_jsx(Input, { id: id, type: type, value: value, className: className, placeholder: placeholder, onChange: onChange, disabled: disabled, required: required, autoFocus: autoFocus, onFocus: onFocus, onBlur: onBlur, ispassive: Boolean(passive || ispassive), textAlign: textAlign, cornerStyle: cornerStyle, autoComplete: shouldDisallowAutoComplete ? 'off' : undefined, ...extraAttrs }));
};
export default TextField;
